export default {"src":"/_next/static/media/warning-red-black.257239c6.svg","height":474,"width":474};